export default __webpack_public_path__ + "static/media/APRDOM2026.33cce893.png";